import React from "react";
import { Controller } from "react-hook-form";
import InputField from "@components/common/InputField";
import type { Control } from "react-hook-form";
import { createLabSchema } from "../../../schema";
import { z } from "zod";
import { useTranslation } from "react-i18next";

type LabFormData = z.infer<typeof createLabSchema>;

interface LabNameFieldProps {
	control: Control<LabFormData>;
	isSubmitting: boolean;
}

const LabNameField: React.FC<LabNameFieldProps> = ({ control, isSubmitting }) => {
	const { t } = useTranslation();
	return (
		<Controller
			name="name"
			control={control}
			render={({ field, fieldState }) => (
				<InputField
					id="lab-name"
					label={t("feature.courseBuilder.labs.createLab.labName")}
					type="text"
					placeholder={t("feature.courseBuilder.labs.createLab.enterLabName")}
					error={!!fieldState.error}
					helperText={fieldState.error?.message}
					disabled={isSubmitting}
					required
					{...field}
					value={field.value || ""}
				/>
			)}
		/>
	);
};

export default LabNameField;
